module.exports = __webpack_public_path__ + "static/media/events-square.3bb749d1.jpg";